import { LocationQuery } from 'vue-router'

import EventBus from '@/modules/event-bus'
import { CLID_PARAM } from '@/router/query-params'

export const XIAOMI_TEST_CLID = 'xiaomi_store'

declare global {
    interface Window {
        funmax?: {
            loadStart?: () => void
            loadReady?: () => void
        }
    }
}

export class XiaomiIntegration {
    public enabled
    constructor({ queryParams }: { queryParams: LocationQuery }) {
        this.enabled = queryParams[CLID_PARAM] === XIAOMI_TEST_CLID
    }
    listen(bus: EventBus<Record<string, Record<string, unknown>>>) {
        if (this.enabled) {
            this.handleLoadStart()
            bus.addEventListener('liveness', this.handleLoadReady)
        }
    }

    handleLoadStart() {
        try {
            window.funmax?.loadStart?.()
        } catch (e) {
            console.error(e)
        }
    }
    handleLoadReady() {
        try {
            window.funmax?.loadReady?.()
        } catch (e) {
            console.error(e)
        }
    }
}
